module.exports = __webpack_public_path__ + "static/img/study-grey.04ca1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-img/study-grey.png
// module id = NXjc
// module chunks = 1